export const USER_REACTION_BAR_TEST_ID = "user-reaction-bar";
export const USER_REACTION_OPTION_TEST_ID = "user-reaction-option";
export const USER_REACTION_OPTION_RESULT_TEST_ID = "user-reaction-option-result";
